import { Button, Icon, Spinner, Tooltip } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'

export const DeleteButton = ({
  processing = false,
  className = '',
  onClick = () => {},
}) => {
  const { t } = useTranslation()

  return (
    <Tooltip title={t(`services::accesses.list.extra_actions.delete`)}>
      {processing ? (
        <Spinner width={24} />
      ) : (
        <Button
          color={'Interface-Eighth'}
          startIcon={<Icon name={'trash'} />}
          noLabel
          size={'s'}
          className={className}
          onClick={onClick}
        />
      )}
    </Tooltip>
  )
}

DeleteButton.propTypes = {
  action: PropTypes.string,
  login: PropTypes.string,
  icon: PropTypes.string,
  processing: PropTypes.bool,
  className: PropTypes.string,
  toggleTo: PropTypes.oneOf(['activate', 'archive']),
  checkboxHandleChange: PropTypes.func,
  onClick: PropTypes.func,
}
